module.exports = __webpack_public_path__ + "img/lang_left.55ed28b0.png";